import { render, staticRenderFns } from "./addZhuti.vue?vue&type=template&id=0ad4690e&scoped=true&"
import script from "./addZhuti.vue?vue&type=script&lang=js&"
export * from "./addZhuti.vue?vue&type=script&lang=js&"
import style0 from "./addZhuti.vue?vue&type=style&index=0&id=0ad4690e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad4690e",
  null
  
)

export default component.exports